import { Receipt } from 'lucide-react';
import { Button } from '../Button';

interface EmptyStateProps {
  onAddExpense?: () => void;
}

export function EmptyState({ onAddExpense }: EmptyStateProps) {
  return (
    <div className="bg-white rounded-lg border border-[#E2E8F0] py-20 flex flex-col items-center justify-center">
      {/* Icon */}
      <div className="w-16 h-16 rounded-full bg-[#F7FAFC] flex items-center justify-center mb-4">
        <Receipt size={32} className="text-[#A0AEC0]" />
      </div>

      {/* Title */}
      <h3 className="text-[18px] leading-[24px] font-semibold text-[#4A5568] mb-2">
        No expenses yet
      </h3>

      {/* Description */}
      <p className="text-[14px] text-[#718096] mb-6">
        Add your first expense to start tracking
      </p>

      {/* CTA Button */}
      <Button 
        variant="primary" 
        size="default"
        onClick={onAddExpense}
      >
        Add Expense
      </Button>
    </div>
  );
}
